import { render, staticRenderFns } from "./RegisterSection.vue?vue&type=template&id=387c6cc8&scoped=true"
import script from "./RegisterSection.vue?vue&type=script&lang=js"
export * from "./RegisterSection.vue?vue&type=script&lang=js"
import style0 from "./RegisterSection.vue?vue&type=style&index=0&id=387c6cc8&prod&lang=scss&scoped=true"
import style1 from "./RegisterSection.vue?vue&type=style&index=1&id=387c6cc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c6cc8",
  null
  
)

export default component.exports